<div class="container-fluid h-100 p-0" style="position: relative">
  <div class="d-flex justify-content-center h-100">
    <div
      class="card p-0 w-100"
      style="min-height: 570px; border: 0; border-radius: 0"
      [style.background-color]="clozeTestStyleModel().exerciseBackground">
      <!-- mobile exercise header -->
      <div class="onset-indicator d-flex justify-content-between" style="align-items: center">
        <div>
          @if (!exampleDone) {
            <span class="font-weight-bold"> {{ "GAST-ONSET-NG.MOBILE.EXERCISE_EXAMPLE.EXAMPLE" | translate }}</span>
          }
        </div>
        <div>
          <img style="max-width: 100px" [src]="cTestLogo()" alt="Logo" />
        </div>
      </div>
      <div
        class="card-body card-mobile"
        [style.font-family]="clozeTestStyleModel().font"
        [style.font-size]="this.clozeTestStyleModel().fontSize">
        @if (!exampleDone) {
          <div>
            <h5 class="card-title text-center font-weight-bold">{{ title }}</h5>
            <!-- Content -->
            <div [style.line-height]="lineHeight" style="padding-top: 10px">
              @for (input of inputs; track input; let i = $index) {
                <onset-cloze-test-exercise-input
                  [mobileMode]="true"
                  [nr]="$any(input.id)"
                  [text]="input.text"
                  [isLast]="i === inputs.length - 1"
                  [lastWord]="input.lastWord"
                  [answer]="input.answer">
                </onset-cloze-test-exercise-input>
              }
            </div>
            <!-- Next button -->
            <div class="text-center" style="padding-top: 10px">
              <div class="row justify-content-around">
                <div class="col-2"></div>
                <div class="col-4" style="padding-top: 4px">
                  <input
                    type="checkbox"
                    style="vertical-align: middle"
                    id="finishCheckbox"
                    name="finishCheckbox"
                    [checked]="readyCheckbox"
                    (change)="readyCheckbox = !readyCheckbox" />
                  <label class="font-weight-bold" for="finishCheckbox" style="font-size: smaller; padding-left: 6px">{{
                    "GAST-ONSET-NG.MOBILE.EXERCISE_EXAMPLE.DONE" | translate
                  }}</label>
                </div>
                <div class="col-4">
                  <button
                    class="btn"
                    style="font-size: smaller"
                    (click)="toggleExampleDone()"
                    [hidden]="!readyCheckbox"
                    [disabled]="!readyCheckbox"
                    [style.background-color]="cTestButtonColor()">
                    {{ "GAST-ONSET-NG.MOBILE.EXERCISE_EXAMPLE.NEXT" | translate }}
                  </button>
                </div>
                <div class="col-2"></div>
              </div>
            </div>
            <div class="text-center">
              <div class="row justify-content-around">
                <!-- Mobile keyboard -->
                <div style="margin-top: 8px" class="container-fluid mobile-keyboard">
                  <div class="d-flex justify-content-center keyboard-row">
                    <button
                      #buttonVar
                      class="mobile-keyboard-button"
                      (touchstart)="assignCharacter('q', $event)"
                      (touchend)="onTouchend($event)">
                      {{ "q" }}
                    </button>

                    @for (character of FIRST_KEYBOARD_ROW; track character; let lastCharacter = $last) {
                      <button
                        class="mobile-keyboard-button"
                        [class.mr-0]="lastCharacter"
                        (touchstart)="assignCharacter(character, $event)"
                        (touchend)="onTouchend($event)">
                        {{ character }}
                      </button>
                    }
                  </div>

                  @for (keyboardRow of KEYBOARD_ROWS; track keyboardRow; let lastRow = $last) {
                    <div class="d-flex justify-content-center keyboard-row" style="margin-top: 4px">
                      @for (character of keyboardRow; track character; let lastCharacter = $last) {
                        <button
                          class="mobile-keyboard-button"
                          [class.mr-0]="lastCharacter"
                          [ngStyle]="lastRow ? { 'max-width.px': buttonVar.offsetWidth } : {}"
                          (touchstart)="assignCharacter(character, $event)"
                          (touchend)="onTouchend($event)">
                          {{ character }}
                        </button>
                        @if (lastRow && lastCharacter) {
                          <button
                            [ngStyle]="{ 'max-width.px': buttonVar.offsetWidth * 2 }"
                            class="mobile-keyboard-button remove-button mr-0"
                            (touchstart)="removeLastCharacter($event)"
                            (touchend)="onTouchend($event)">
                            <i class="fas fa-backspace" style="pointer-events: none"></i>
                          </button>
                        }
                      }
                    </div>
                  }
                  <div class="d-flex justify-content-center keyboard-row" style="margin-top: 4px">
                    <div class="col-4" style="line-height: 1.15 !important"></div>
                    <div class="col-4" style="padding-left: 0; padding-right: 0">
                      <button
                        class="mobile-keyboard-button"
                        style="width: 33%; background-color: #50b4ae"
                        (touchstart)="goToPreviousInput($event)">
                        <i class="fas fa-caret-left"></i>
                      </button>
                      <button
                        class="mobile-keyboard-button"
                        style="width: 33%; background-color: #50b4ae"
                        (touchstart)="goToNextInput($event)">
                        <i class="fas fa-caret-right"></i>
                      </button>
                    </div>
                    <div class="col-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (exampleDone) {
          <div>
            <div class="text-center" style="padding-top: 200px">
              <div class="row justify-content-around">
                <p class="card-text">{{ "GAST-ONSET-NG.MOBILE.EXERCISE_EXAMPLE.START_TEST_INFO" | translate }}</p>
              </div>
              <div class="row justify-content-around mt-4">
                <button
                  class="btn"
                  style="font-size: smaller"
                  [style.background-color]="cTestButtonColor()"
                  (click)="toggleStartTest()">
                  {{ "GAST-ONSET-NG.MOBILE.EXERCISE_EXAMPLE.START_TEST" | translate }}
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
